import React from 'react';
import TenantDeploy from './TenantDeploy';

const DeploymentsBeta = () => {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-200">Deployments (Beta) — Per-Tenant</h1>
        <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">
          Deploy BackOffice and Simulcast for one or more tenants in a single action.
        </p>
      </div>

      <div className="bg-white dark:bg-slate-900 rounded-xl border border-gray-200 dark:border-slate-700 p-6">
        <TenantDeploy />
      </div>
    </div>
  );
};

export default DeploymentsBeta;
